import { SET_AUTHENTICATION } from '../store/actionTypes'

export const setAuthentication = (auth) => (
  {
    type: SET_AUTHENTICATION,
    payload: auth,
  }
)
